import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const initialState: any = {
  showAIConversation: false,
  provinceList: [],
  districtList: [],
  wardList: [],
  moduleList: [],
  newWardList: [],
  bankSupportList: [],
  schoolModuleList: [],
  userDetail: null,
  loadingProvince: false,
  loadingDistric: false,
  loadingWard: false,
  loadingNewWard: false,
  loadingBankSupport: false,
  loadingUserDetail: false,
  isBossPlayAudio: false,
  namePlayAudio: '',
}

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setProvinceList(state, action: PayloadAction<any>) {
      state.provinceList = action.payload
    },
    setDistrictList(state, action: PayloadAction<any>) {
      state.districtList = action.payload
    },
    setWardList(state, action: PayloadAction<any>) {
      state.wardList = action.payload
    },
    setModuleList(state, action: PayloadAction<any>) {
      state.moduleList = action.payload
    },
    setBankSupportList(state, action: PayloadAction<any>) {
      state.bankSupportList = action.payload
    },
    setLoadingProvince(state, action: PayloadAction<any>) {
      state.loadingProvince = action.payload
    },
    setLoadingDistrict(state, action: PayloadAction<any>) {
      state.loadingDistric = action.payload
    },
    setLoadingWard(state, action: PayloadAction<any>) {
      state.loadingWard = action.payload
    },
    setLoadingModule(state, action: PayloadAction<any>) {
      state.loadingModule = action.payload
    },
    setLoadingBankSupport(state, action: PayloadAction<any>) {
      state.loadingBankSupport = action.payload
    },
    setSchoolModuleList(state, action: PayloadAction<any>) {
      state.schoolModuleList = action.payload
    },
    setUserDetail(state, action: PayloadAction<any>) {
      state.userDetail = action.payload;
    },
    setLoadingSchoolModule(state, action: PayloadAction<any>) {
      state.loadingSchoolModule = action.payload
    },
    setLoadingUserDetail(state, action: PayloadAction<any>) {
      state.loadingUserDetail = action.payload;
    },
    setNewWardList(state, action: PayloadAction<any>) {
      state.newWardList = action.payload
    },
    setLoadingNewWard(state, action: PayloadAction<any>) {
      state.loadingNewWard = action.payload
    },
    setIsBossPlayAudio: (state, action: PayloadAction<{ isBossPlayAudio: boolean; namePlayAudio: string }>) => {
      state.isBossPlayAudio = action.payload.isBossPlayAudio;
      state.namePlayAudio = action.payload.namePlayAudio;
    },
    clearIsBossPlayAudio: (state) => {
      state.isBossPlayAudio = false;
      state.namePlayAudio = '';
    },
    setShowAIConversation: (state, action: PayloadAction<boolean>) => {
      state.showAIConversation = action.payload;
    },
    clearModuleList: (state) => {
      state.moduleList = [];
    },
  }
})

export const {
  setProvinceList,
  setDistrictList,
  setWardList,
  setBankSupportList,
  setLoadingProvince,
  setLoadingDistrict,
  setLoadingWard,
  setLoadingModule,
  setLoadingBankSupport,
  setModuleList,
  setSchoolModuleList,
  setLoadingSchoolModule,
  setUserDetail,
  setLoadingUserDetail,
  setNewWardList,
  setLoadingNewWard,
  setIsBossPlayAudio,
  clearIsBossPlayAudio,
  setShowAIConversation,
  clearModuleList

} = commonSlice.actions;

export default commonSlice.reducer;